const stockAdjustmentId = {
	stock_adjustment: {
		title: "Penyesuaian Stock",
		subtitle: "Ringkasan daftar penyesuaian stok",
	table: {
		title: "Data Stock Keluar",
		columns: {
			date: "Tanggal",
			ref_id: "Ref ID",
			store: "Toko",
			notes: "Catatan",
			created_by: "Dibuat Oleh",
			status: "Status",
		},
	},
		empty_state: {
			title: {
				has_filter: "Tidak ada data yang sesuai",
				no_filter: "Tidak ada data Penyesuaian Stok",
			},
			description: {
				has_filter:
					"Tidak ditemukan data dengan filter yang dipilih. Coba ubah filter Anda.",
				no_filter: "Silakan tambahkan data Penyesuaian Stock baru.",
			},
		},
	forms: {
		edit: {
			title: "Edit Penyesuaian Stok",
			info: "Informasi penyesuaian stok",
			fields: {
				ref_id: {
					label: "RefId",
					placeholder: "refId",
				},
				store: {
					label: "Toko",
					placeholder: "Pilih Toko",
				},
				notes: {
					label: "Catatan",
					placeholder: "catatan",
				},
				status: {
					label: "Status",
					placeholder: "Pilih Status",
				},
			},
			options: {
				active: "Aktif",
				inactive: "Tidak Aktif",
			},
		},
		add: {
				button: "Tambah Penyesuaian Stok",
				title: "Tambah Penyesuaian Stok",
				description: "Tambah data Penyesuaian Stok baru",
				fields: {
					store: {
						label: "Toko",
						placeholder: "Pilih toko",
					},
					notes: {
						label: "Catatan",
						placeholder: "Masukkan Catatan",
					},
					processed_at: {
						label: "Tanggal proses",
					},
					product_detail: {
						title: "Detail Produk",
						loading: "Memuat produk...",
						product: {
							label: "Produk",
							placeholder: "Pilih Produk",
							search_product: "Cari Produk...",
							not_found_product: "Tidak ada product yang ditemukan",
						},
						current_stock: {
							label: "Stock saat ini",
							placeholder: "0",
						},
						adjustment_stock: {
							label: "Stock Penyesuaian",
							placeholder: "0",
						},
						stock_differences: {
							label: "Selisih",
							placeholder: "0",
						},
						unit: {
							label: "Satuan",
							placeholder: "Pcs",
						},
						action: {
							label: "Aksi",
						},
					},
				},
			},
		},
		actions: {
			save: "Simpan",
			saving: "Menyimpan...",
			cancel: "Batal",
			save_changes: "Simpan Perubahan",
			add_products: {
				already_added: "Produk ini sudah ditambahkan",
				button: "Tambahkan Produk lagi",
			},
		},
		status: {
			processed: "Sudah diproses",
			inactive: "Tidak Aktif",
			active: "Aktif",
		},
	},
};

export default stockAdjustmentId;
